
import '../styles/ContactPage.css'; import React, { useState } from 'react';
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaPaw, FaHeart, FaPaperPlane } from 'react-icons/fa';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitSuccess(true);
      setFormData({ name: '', email: '', subject: '', message: '' });
      
      // Reset success message after 5 seconds
      setTimeout(() => setSubmitSuccess(false), 5000);
    }, 1500);
  };

  return (
    <div className="contact-page">
        <br/><br/><br/>
      <div className="contact-header">
        <div className="header-content">
          <h1>Get in Touch</h1>
          <p>Have questions about adoption? Our team is ready to help you find your perfect furry companion!</p>
          <div className="paw-decoration">
            <FaPaw className="paw-icon" />
            <FaPaw className="paw-icon" />
            <FaPaw className="paw-icon" />
          </div>
        </div>
      </div>
      
      <div className="contact-container">
        <div className="contact-info">
          <div className="info-card">
            <div className="info-icon">
              <FaEnvelope />
            </div>
            <h3>Email Us</h3>
            <p>adoptions@pawsandclaws.com</p>
            <p>support@pawsandclaws.com</p>
          </div>
          
          <div className="info-card">
            <div className="info-icon">
              <FaPhoneAlt />
            </div>
            <h3>Call Us</h3>
            <p>Adoption Hotline: (555) 123-4567</p>
            <p>General Inquiries: (555) 987-6543</p>
          </div>
          
          <div className="info-card">
            <div className="info-icon">
              <FaMapMarkerAlt />
            </div>
            <h3>Visit Us</h3>
            <p>123 Pet Adoption Lane</p>
            <p>San Francisco, CA 94110</p>
            <p>Open: Mon-Sat 9am-6pm</p>
          </div>
        </div>
        
        <div className="contact-form">
          <div className="form-header">
            <h2>Send us a message</h2>
            <p>We're here to answer any questions about our adoption process.</p>
          </div>
          
          {submitSuccess && (
            <div className="success-message">
              <div className="success-icon">
                <FaHeart />
              </div>
              <div>
                <h3>Message Sent!</h3>
                <p>We'll contact you within 24 hours</p>
              </div>
            </div>
          )}
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input 
                type="text" 
                name="name" 
                value={formData.name}
                onChange={handleChange}
                placeholder="Full Name"
                required
              />
            </div>
            
            <div className="form-group">
              <input 
                type="email" 
                name="email" 
                value={formData.email}
                onChange={handleChange}
                placeholder="Email Address"
                required
              />
            </div>
            
            <div className="form-group">
              <input 
                type="text" 
                name="subject" 
                value={formData.subject}
                onChange={handleChange}
                placeholder="Subject"
                required
              />
            </div>
            
            <div className="form-group">
              <textarea 
                name="message" 
                rows={5}
                value={formData.message}
                onChange={handleChange}
                placeholder="Your message..."
                required
              ></textarea>
            </div>
            
            <button 
              type="submit" 
              className="submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <span className="spinner"></span>
              ) : (
                <>
                  Send Message <FaPaperPlane className="send-icon" />
                </>
              )}
            </button>
          </form>
        </div>
      </div>
      
      <div className="map-section">
        <h2>Find Our Adoption Center</h2>
        <div className="map-container">
          <div className="map-placeholder">
            <div className="map-overlay">
              <div className="map-marker">
                <FaMapMarkerAlt />
              </div>
              <div className="map-zoom-controls">
                <button className="zoom-btn">+</button>
                <button className="zoom-btn">-</button>
              </div>
            </div>
          </div>
          <div className="map-info">
            <p><strong>Paws & Claws Adoption Center</strong></p>
            <p>123 Pet Adoption Lane, San Francisco, CA 94110</p>
            <p>Free parking available | Wheelchair accessible</p>
          </div>
        </div>
      </div>
      
      <div className="contact-cta">
        <div className="cta-content">
          <h2>Ready to Adopt a New Friend?</h2>
          <p>Browse our available pets and start the adoption process today!</p>
          <button className="cta-button">View Available Pets</button>
        </div>
        <div className="cta-decoration">
          <div className="heart-icon">
            <FaHeart />
          </div>
          <div className="paw-icon">
            <FaPaw />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;